import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinmadras() {



  const cardData =
  {
    keyword: ' Corporate Cab Services in Madras',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Services in Madras',
    headingDescription: 'Pune Corporate Cars India Private Limited provides professional and reliable Corporate Cab Services in Madras, catering to the transportation needs of IT parks, corporate offices, business centers, and industrial hubs across the city. Our fleet of executive sedans, SUVs, and premium vehicles ensures safe, comfortable, and timely travel for employees, clients, and senior executives. Whether it is daily office commute, airport transfers, inter-office travel, business meetings, or VIP transportation, we deliver seamless and hassle-free mobility solutions. With trained chauffeurs, flexible rental plans, and well-maintained vehicles, Pune Corporate Cars India Private Limited ensures a premium and dependable corporate travel experience for businesses operating in and around Madras.',

    top: 'Top Places to Visit in Madras with Pune Corporate Car',

"topPlaces": [
  {
    "title": "Marina Beach",
    "description": "Marina Beach is the iconic shoreline of Madras (now Chennai), stretching over 13 km along the Bay of Bengal. It is one of the longest urban beaches in the world, attracting locals and tourists for jogging, kite flying, picnics, and street food like sundal and murukku. The beach comes alive during festivals and evening strolls, making it a hub for leisure, culture, and social gatherings."
  },
  {
    "title": "Kapaleeshwarar Temple",
    "description": "Kapaleeshwarar Temple in Mylapore is a stunning example of Dravidian architecture, dedicated to Lord Shiva. Famous for its colorful gopuram, intricate carvings, and serene inner sanctum, it draws devotees and tourists alike. The temple hosts vibrant festivals, traditional rituals, and cultural programs, reflecting the city’s rich spiritual and cultural heritage."
  },
  {
    "title": "Fort St. George",
    "description": "Fort St. George, built in 1644 by the British East India Company, is a historical landmark and administrative hub in Madras. The fort houses St. Mary’s Church, the Tamil Nadu Legislative Assembly, and a museum showcasing colonial-era artifacts. Visitors can explore the ramparts, bastions, and exhibits, gaining insights into the city’s colonial past and military architecture."
  },
  {
    "title": "Santhome Cathedral Basilica",
    "description": "Santhome Cathedral Basilica is a majestic Gothic-style church built over the tomb of St. Thomas, one of Jesus Christ’s apostles. Known for its stained-glass windows and intricate interiors, the church attracts pilgrims and tourists alike. It serves as both a place of worship and a significant historical and architectural landmark in Madras."
  },
  {
    "title": "Guindy National Park",
    "description": "Guindy National Park is one of India’s smallest national parks, located within the urban limits of Madras. It houses diverse wildlife including deer, blackbucks, and exotic birds, and includes the Snake Park and Children’s Park. The park offers walking trails, picnic areas, and a peaceful green escape from the city’s hustle, ideal for families, nature lovers, and students."
  },
  {
    "title": "Valluvar Kottam",
    "description": "Valluvar Kottam is a monument dedicated to the revered Tamil poet Thiruvalluvar. Its grand chariot-shaped auditorium and intricately carved walls depict the poet’s works and Tamil cultural heritage. It is a cultural landmark, attracting visitors interested in literature, history, and architectural artistry in Madras."
  },
  {
    "title": "Elliot’s Beach",
    "description": "Elliot’s Beach, located in Besant Nagar, is a quieter alternative to Marina Beach, offering calm waters, scenic sunsets, and peaceful walks. The beach is lined with local cafés and eateries, making it a favorite spot for families, couples, and youth seeking relaxation and a laid-back seaside experience."
  },
  {
    "title": "Theosophical Society",
    "description": "The Theosophical Society in Adyar is a sprawling campus of greenery, spiritual learning, and historical architecture. Famous for its century-old trees, serene gardens, and the massive Adyar Banyan Tree, it offers a tranquil environment for meditation, birdwatching, and quiet exploration, reflecting the philosophical and cultural heritage of Madras."
  },
  {
    "title": "Chennai Rail Museum",
    "description": "The Chennai Rail Museum showcases the evolution of railways in India, featuring vintage locomotives, carriages, interactive exhibits, and miniature train rides. It is an educational and entertaining destination for families, students, and railway enthusiasts, offering insights into the history and technology of Indian Railways."
  },
  {
    "title": "Semmozhi Poonga",
    "description": "Semmozhi Poonga is a beautifully landscaped botanical garden in Madras, featuring themed gardens, exotic plant species, walking paths, and open lawns. It is perfect for morning walks, photography, and leisure outings, providing a green retreat in the midst of the bustling city."
  }
],


"services": [
{
"name": "Madras Corporate Cabs",
"description": "Madras Corporate Cabs offers end-to-end corporate transportation solutions for employees, executives, and business visitors across Madras. The service includes well-maintained sedans, SUVs, and shuttle vehicles with GPS tracking, trained drivers, optimized routes, and real-time monitoring. It supports multi-shift operations, flexible scheduling, and ensures safe, timely, and comfortable daily commuting for corporate staff."
},
{
"name": "Business Taxi Madras",
"description": "Business Taxi Madras provides premium taxi services for corporate meetings, client visits, airport transfers, and inter-office travel. With professional drivers, GPS-enabled vehicles, and comfortable seating, it ensures punctual and reliable transport for employees and business executives in Madras."
},
{
"name": "Employee Commute Madras",
"description": "Employee Commute Madras delivers structured daily commute solutions for office and factory employees. The service features optimized routes, real-time vehicle tracking, trained drivers, and multi-shift support, guaranteeing safe, efficient, and reliable transportation for staff across Madras."
},
{
"name": "Staff Shuttle Madras",
"description": "Staff Shuttle Madras provides high-capacity shuttle services using AC minibuses and vans for bulk staff transport. The service includes route optimization, attendance integration, GPS monitoring, and professional chauffeurs, making it ideal for IT parks, corporate offices, and industrial zones in Madras."
},
{
"name": "Office Cab Madras",
"description": "Office Cab Madras offers dedicated daily cab services for employees commuting to corporate offices. With fixed and flexible routes, trained drivers, GPS-enabled vehicles, and efficient scheduling, the service ensures safe, comfortable, and punctual travel for all workforce categories."
},
{
"name": "Monthly Corporate Cab Madras",
"description": "Monthly Corporate Cab Madras provides long-term cab rental solutions for companies requiring consistent employee transportation. The service includes dedicated vehicles, driver deployment, GPS tracking, flexible monthly plans, and end-to-end fleet management, ensuring uninterrupted and cost-effective commute services."
},
{
"name": "Best Corporate Taxi Madras",
"description": "Best Corporate Taxi Madras delivers top-tier corporate mobility services with premium sedans and SUVs, highly trained chauffeurs, and strict safety standards. Ideal for executives, managers, and business visitors, it ensures a smooth, professional, and comfortable travel experience across the city."
},
{
"name": "Affordable Cab Madras",
"description": "Affordable Cab Madras provides budget-friendly corporate transport without compromising safety or comfort. Designed for SMEs and startups, it includes well-maintained vehicles, trained drivers, GPS-enabled tracking, and reliable daily commute solutions for employees."
},
{
"name": "Outstation Cab Madras",
"description": "Outstation Cab Madras offers long-distance corporate travel services for client visits, factory tours, and business trips. Equipped with comfortable sedans and SUVs, professional chauffeurs, GPS tracking, and planned routes, the service ensures safe and convenient intercity travel for employees and executives."
},
{
"name": "Sedan Cab Madras",
"description": "Sedan Cab Madras provides premium sedans for corporate executives, managers, and visitors. Each vehicle is well-maintained, comfortable, and driven by trained chauffeurs, ensuring a safe, reliable, and refined commute for office travel, client meetings, and airport transfers."
},
{
"name": "SUV Cab Madras",
"description": "SUV Cab Madras offers spacious and high-comfort SUVs ideal for team travel, senior executive mobility, industrial visits, and long-distance corporate trips. Vehicles are GPS-enabled, professionally maintained, and driven by trained drivers to provide a premium corporate travel experience."
},
{
"name": "Company Transport Madras",
"description": "Company Transport Madras specializes in large-scale employee mobility solutions for corporate offices, factories, and IT parks. The service provides structured routing, multi-shift support, trained drivers, vehicle maintenance, and real-time tracking to ensure safe, efficient, and reliable staff transportation."
},
{
"name": "Corporate Fleet Madras",
"description": "Corporate Fleet Madras provides fleet management and outsourcing services for businesses requiring multiple vehicles for employee commute, executive travel, and bulk staff transport. It includes sedans, SUVs, shuttle vans, professional drivers, maintenance support, and GPS-enabled monitoring for seamless corporate mobility."
},
{
"name": "Chauffeur Car Madras",
"description": "Chauffeur Car Madras offers professionally trained drivers for executives, senior management, and business visitors. The service ensures punctual, safe, and comfortable travel for office commutes, client meetings, airport transfers, and outstation trips, backed by modern vehicles and GPS-enabled safety protocols."
},
{
"name": "Employee Mobility Madras",
"description": "Employee Mobility Madras delivers comprehensive workforce transport solutions for companies of all sizes. The service integrates daily commute planning, shuttle services, fleet management, driver management, GPS tracking, and multi-shift operations to provide safe, efficient, and reliable employee mobility across Madras."
}
],

"tableData": [
["Madras Corporate Cabs", "Business Taxi Madras"],
["Employee Commute Madras", "Staff Shuttle Madras"],
["Office Cab Madras", "Monthly Corporate Cab Madras"],
["Best Corporate Taxi Madras", "Affordable Cab Madras"],
["Outstation Cab Madras", "Sedan Cab Madras"],
["SUV Cab Madras", "Company Transport Madras"],
["Corporate Fleet Madras", "Chauffeur Car Madras"],
["Employee Mobility Madras", ""]
],


  





"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Services in Madras",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides dependable corporate cab services in Madras (Chennai), ensuring smooth and efficient transportation for employees and business executives."
  },
  {
    "WhyChooseheading": "Timely Pickups & Drop-offs",
    "WhyChoosedescription": "We guarantee punctual pickups and drop-offs across Madras’ corporate hubs, IT parks, and industrial areas, helping employees reach offices and meetings on time."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained chauffeurs provide safe, courteous, and disciplined travel, ensuring a comfortable and secure commute for corporate clients."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—all sanitized, serviced, and maintained for safe and reliable corporate travel."
  },
  {
    "WhyChooseheading": "Customized Corporate Travel Packages",
    "WhyChoosedescription": "We offer flexible cab rental plans tailored to meet the commuting requirements of businesses and employees in Madras."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Support",
    "WhyChoosedescription": "Our support team provides round-the-clock assistance for bookings, emergencies, and route adjustments, ensuring uninterrupted corporate travel."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are regularly sanitized and equipped with modern safety features, providing secure and comfortable rides for employees and executives."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Corporate travel is managed effortlessly through our streamlined booking system and reliable coordination, making employee transport hassle-free."
  }
]



































  }

const faqData = [
  {
    question: 'Do you provide corporate cab services in Madras?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers professional and reliable corporate cab services for companies and employees across Madras (Chennai).',
  },
  {
    question: 'What types of corporate cab services are available in Madras?',
    answer: 'We provide employee transportation, corporate pickups and drops, airport transfers, shuttle services, and dedicated fleet solutions for businesses.',
  },
  {
    question: 'Do you support daily commuting for employees in Madras?',
    answer: 'Yes, we offer structured daily commute services with punctual pickups, optimized routes, and multi-shift transportation for corporate employees.',
  },
  {
    question: 'How can companies book corporate cab services in Madras?',
    answer: 'Bookings can be made through our website, mobile app, or via our 24×7 corporate support team.',
  },
  {
    question: 'Which vehicles are available for corporate travel in Madras?',
    answer: 'We offer hatchbacks, sedans, SUVs, luxury cars, Innova Crysta, and tempo travellers depending on company requirements.',
  },
  {
    question: 'Do you provide long-term corporate cab contracts in Madras?',
    answer: 'Yes, we provide flexible monthly, quarterly, and annual corporate transportation contracts with transparent pricing.',
  },
  {
    question: 'Are your corporate cabs equipped with GPS and safety features?',
    answer: 'All vehicles are GPS-enabled, sanitized regularly, and driven by trained and verified chauffeurs to ensure employee safety.',
  },
  {
    question: 'Do you manage multi-shift employee transportation in Madras?',
    answer: 'Yes, we support early morning, night, weekend, and rotational shifts for corporate employees across Madras.',
  },
  {
    question: 'What payment options are available for corporate cab services in Madras?',
    answer: 'We accept UPI, credit/debit cards, bank transfers, digital wallets, and provide corporate invoicing for monthly payments.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ravi Shankar',
    feedback: 'Reliable and efficient corporate cab service in Madras. Drivers are punctual and vehicles are well-maintained.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Anitha Krishnan',
    feedback: 'Professional and convenient corporate transportation service. Perfect solution for daily employee commute in Madras.',
    rating: 5,
  },
];





































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Madras",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cab-madras.jpg", // replace with correct image if needed
  "description":
    "Pune Corporate Cars India Private Limited provides professional corporate cab services in Madras, including business taxis, employee commute solutions, staff shuttles, office pickups & drops, monthly corporate cab plans, outstation trips, chauffeur-driven cars, and corporate fleet solutions for companies operating in Madras.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-services-madras"
  }
};






  return (
    <div>
<Helmet>
  <title>Corporate Cab Services in Madras | Employee & Business Transport</title>

  <meta
    name="description"
    content="Reliable corporate cab services in Madras including business taxis, employee commute, staff shuttles, office pickups & drops, monthly corporate cab plans, outstation trips, and chauffeur-driven vehicles."
  />

  <meta
    name="keywords"
    content="Madras Corporate Cabs, Business Taxi Madras, Employee Commute Madras, Staff Shuttle Madras, Office Cab Madras, Monthly Corporate Cab Madras, Best Corporate Taxi Madras, Affordable Cab Madras, Outstation Cab Madras, Sedan Cab Madras, SUV Cab Madras, Company Transport Madras, Corporate Fleet Madras, Chauffeur Car Madras, Employee Mobility Madras"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/68.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinmadras;